import {
  Dashboard,
  DashboardByUserQueryVariables,
  DashboardDeviceType,
  GetDashboardQuery,
  GetDashboardQueryVariables,
  ListDashboardsQueryVariables,
  createListAllQuery,
  dashboardByUser,
  getDashboard,
  graphqlCall,
  listDashboards,
} from '@akin-home/amplify';

export const listAllDashboardsQuery = createListAllQuery<
  Dashboard,
  ListDashboardsQueryVariables
>(listDashboards, 'listDashboards');

export const listAllDashboardsForUserQuery = createListAllQuery<
  Dashboard,
  DashboardByUserQueryVariables
>(dashboardByUser, 'dashboardByUser');

export const listAllTabletDashboardsForUser = (user_id: string) => {
  return listAllDashboardsForUserQuery({
    user_id,
    filter: {
      device_type: {
        eq: DashboardDeviceType.tablet,
      },
    },
  });
};

export const getDashboardQuery = (params: GetDashboardQueryVariables) =>
  graphqlCall<GetDashboardQuery>(getDashboard, params);
